import validate from 'lib/utils/validationRules';

export default async function paymentAccessPermission({ to, next, store }) {
  const { query } = to;

  if (!validate.isObjectWithFields(query, ['paymentId', 'processToken'])) {
    return next({ name: 'service.error' });
  }

  if (validate.isEmptyString(query.paymentId) || validate.isEmptyString(query.processToken)) {
    return next({ name: 'service.error' });
  }

  try {
    await store.dispatch('GET_PAYMENT', {
      paymentId: query.paymentId,
      processToken: query.processToken,
    });

    return next({ name: 'paid.payment' });
  } catch (error) {
    console.log(error);
    return next({ name: 'service.error' });
  }
}
